import React, { useContext, useRef, useEffect, useState } from 'react';
import CollaborateQAContext from '../../ContextFiles/CollaborateQAContext';
import CollaborateConstants from '../CollaborateTool/Constants';
import { Tooltip, Popover, Input, Button, Row, Col } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const MANAGED_CUSTOMER_USERNAME = localStorage.getItem('managed_customer_username');
const MANAGED_COMPANY_ID = localStorage.getItem('managed_company_id');
const IS_MS_PROVIDER = localStorage.getItem("is_msprovider") === 'true' ? true : false;

const MainOptions = (props) => {
    const matchingShapeIcon = props.basic_action.extra_actions.find(
        (action) => action.main_action === props.objectShape
      );

    return (
        <div className='justify-in-center'>
        <Tooltip placement={"top"}
            title={<span className='manrope f-12 white'>
                {props.basic_action.tooltip}
            </span>}>
            <div className={`tool-box justify-in-center ${props.basic_action.main_action == 'draw' ? 'draw': ''} ${props.annotateLoader || props.save_loader ? `disable` : ``} ${props.selected_action == props.basic_action.main_action ? `product-qa-selected` : ``}`} onClick={() => props.basic_action.main_action == 'draw' ? props.selectAction(props.basic_action.main_action) : props.selectAction(props.basic_action.main_action, matchingShapeIcon.main_action)}>
                {
                    props.basic_action.main_action == 'draw' ? 
                    <>
                        <img src={(props.selected_action == props.basic_action.main_action && props.basic_action.selected_icon) ? props.basic_action.selected_icon : props.basic_action.icon} className={`tool-icons ${props.basic_action.main_action == 'draw' ? 'draw': ''}`}  />
                        <div className='tool-box-text-static main-icon'>
                            <div className={`mb-0 manrope f-12 ${props.objectThickness} tool-box-text-color main-icon ${props.selected_action == props.basic_action.main_action ? 'selected' : ''}`}>
                            </div>
                        </div>
                    </> : 
                    <img src={(props.selected_action == props.basic_action.main_action && matchingShapeIcon.selected_icon) ? matchingShapeIcon.selected_icon : matchingShapeIcon.icon} className={`tool-icons ${props.basic_action.main_action == 'draw' ? 'draw': ''}`}  />
                }
            </div>
        </Tooltip>
        <Popover overlayClassName="sub-toolbar"
            content={
                <div className='display-flex j-c a-c' style={{ gap: "4px"}}>
                    {props.basic_action.extra_actions.map((extra_action, index) => (
                            <Tooltip placement={"top"}
                                key={index}
                                title={<span className='manrope f-12 white'>
                                    {extra_action.tooltip}
                                </span>}>
                                {extra_action.icon_type == "text" ?
                                <div className={`tool-box-text-product ${props.objectThickness == extra_action.main_action ? `product-qa-selected` : ``}`}
                                onClick={() => props.selectAction(props.basic_action.main_action, extra_action.main_action)}>
                                    <div className={`mb-0 manrope f-12 ${extra_action.main_action} ${props.objectThickness == extra_action.main_action ? `selected` : ``} tool-box-text-color`}>
                                    </div>
                                </div> :
                                <div className={`tool-box justify-in-center ${props.objectShape == extra_action.main_action ? `selected-extra` : ``}`}
                                    onClick={() => props.selectAction(props.basic_action.main_action, extra_action.main_action)}>
                                    <img src={props.objectShape == extra_action.main_action ? extra_action.selected_icon : extra_action.icon} className='tool-icons' />
                                </div>}
                            </Tooltip>
                    ))}
                </div>}
            trigger="click"
            open={(props.selected_action === props.basic_action.main_action) &&
                (["text", "shape", "draw"].includes(props.selected_action))}>
                <div className={`${props.annotateLoader || props.save_loader ? `disable` : ``}`}
                style={{padding: '0px 3px', cursor: 'pointer'}}>
                    <DownOutlined />
                </div>
        </Popover>
        </div>
    )
}

const CollaborateCanvasToolbar = () => {
    const { selected_action, secondary_selected_action, objectColor, objectThickness,
        displayLoader, canvasLoader, autoSaveLoader, initialLoader,
        selectAction, changeColor, onColorClick, annotateLoader, refreshLoader,
        save_loader, setCollabSendEmailModal, access_level, productData, objectShape } = useContext(CollaborateQAContext);
    const isMSProivder = (localStorage.getItem("is_msprovider") == "true")

      

    return (
        <>
            <div className="sentinel" style={{ height: '1px' }}></div>
            <Row className={`collaborate-toolbar product-qa display-flex product-qa-toolbar ${initialLoader || (!(IS_MS_PROVIDER && (productData?.customer_username == MANAGED_CUSTOMER_USERNAME || productData?.company_id == MANAGED_COMPANY_ID)) && access_level == "restricted") ? `blur-canvas` : ``} position-fix`}>
                <Col span={24} className='display-flex j-c a-c' style={{ gap: "2px"}}>
                    <>
                        {CollaborateConstants.PRODUCT_COLLABORATE_ACTIONS.map((basic_action, index) => (
                            basic_action.extra_actions.length == 0 ?
                                basic_action.icon_type == "color" ?
                                    <Tooltip key={index}
                                        title={<span className='manrope f-12 white'>
                                            {basic_action.tooltip}
                                        </span>}>
                                        <div className="color-input-wrapper-product-qa" style={{ '--selected-color': objectColor }}>
                                            <div className="selected-color"></div>
                                            <Input
                                                disabled={
                                                annotateLoader ||
                                                save_loader ||
                                                refreshLoader ||
                                                canvasLoader ||
                                                displayLoader ||
                                                autoSaveLoader
                                                }
                                                className="object-color-input"
                                                type="color"
                                                value={objectColor}
                                                onChange={changeColor}
                                                onClick={onColorClick}
                                            />
                                            </div>

                                    </Tooltip> :
                                    <Tooltip key={index}
                                        title={<span className='manrope f-12 white'>
                                            {basic_action.tooltip}
                                        </span>}>
                                        <div
                                            className={`tool-box justify-in-center ${annotateLoader || save_loader || refreshLoader || canvasLoader || displayLoader || autoSaveLoader ? `disable` : ``} ${selected_action == basic_action.main_action ? `product-qa-selected` : ``}`}
                                            onClick={() => selectAction(basic_action.main_action)}>
                                            <img src={(selected_action == basic_action.main_action && basic_action.selected_icon) ? basic_action.selected_icon : basic_action.icon} className='tool-icons' />
                                        </div>
                                    </Tooltip> :
                                <MainOptions
                                    key={index}
                                    basic_action={basic_action}
                                    objectThickness={objectThickness}
                                    objectShape={objectShape}
                                    selected_action={selected_action}
                                    secondary_selected_action={secondary_selected_action}
                                    selectAction={selectAction}
                                    annotateLoader={annotateLoader || refreshLoader || displayLoader || canvasLoader || autoSaveLoader}
                                    save_loader={save_loader}
                                />
                        ))}
                        <div className='collab-divider-container'>
                            <div className='collab-tool-divider'></div>
                        </div>
                    </>

                    <>
                        {access_level != "" && CollaborateConstants.PRODUCT_CANVAS_ACTIONS.map((basic_action, index) => (
                            basic_action.main_action == "select" && access_level != "view" ? "" :
                                (basic_action.main_action == "send_email") ?
                                    (isMSProivder) ?
                                        <Tooltip
                                            key={index}
                                            title={<span className='manrope f-12 white'>
                                                {basic_action.tooltip}
                                            </span>}>
                                            <div
                                                className={`tool-box justify-in-center ${annotateLoader || save_loader || refreshLoader || canvasLoader || displayLoader || autoSaveLoader ? `disable` : ``} ${selected_action == "send_email" ? `product-qa-selected` : ``}`}
                                                onClick={() => setCollabSendEmailModal(true)}>
                                                <img src={basic_action.icon} className='tool-icons' />
                                            </div>
                                        </Tooltip> : "" :
                                    <Tooltip
                                        key={index}
                                        title={<span className='manrope f-12 white'>
                                            {basic_action.tooltip}
                                        </span>}>
                                        <div
                                            className={`tool-box justify-in-center ${annotateLoader || save_loader || refreshLoader || canvasLoader || displayLoader || autoSaveLoader ? `disable` : ``} ${selected_action == basic_action.main_action ? `product-qa-selected` : ``}`}
                                            onClick={() => selectAction(basic_action.main_action, "")}>
                                            <img src={(selected_action == basic_action.main_action && basic_action.selected_icon) ? basic_action.selected_icon : basic_action.icon} className='tool-icons' />
                                        </div>
                                    </Tooltip>
                        ))}
                    </>
                </Col>
            </Row>
        </>
        
    );
}


export default CollaborateCanvasToolbar;
